module.exports = __webpack_public_path__ + "static/media/chexbox-click.4900c77a.svg";